"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/dispute-reason.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fdispute-reason.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.disputeCloseReasonToJSON = exports.disputeCloseReasonFromJSON = exports.disputeReasonToJSON = exports.disputeReasonFromJSON = exports.DisputeCloseReason = exports.DisputeReason = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.common.proto';
var DisputeReason;
(function (DisputeReason) {
    DisputeReason["INVALID_DISPUTE_REASON"] = "INVALID_DISPUTE_REASON";
    /**
     * UNRECOGNIZED_CHARGE - Didn't make this transaction.
     */
    DisputeReason["UNRECOGNIZED_CHARGE"] = "UNRECOGNIZED_CHARGE";
    /**
     * DUPLICATE_CHARGE - Charged multiple times.
     */
    DisputeReason["DUPLICATE_CHARGE"] = "DUPLICATE_CHARGE";
    /**
     * PRODUCT_NOT_RECEIVED - Didn't receive the product.
     */
    DisputeReason["PRODUCT_NOT_RECEIVED"] = "PRODUCT_NOT_RECEIVED";
    /**
     * WRONG_PRODUCT - Product not as described.
     */
    DisputeReason["WRONG_PRODUCT"] = "WRONG_PRODUCT";
    /**
     * REFUND_NOT_RECEIVED - Cancelled the purchase w/o getting a refund.
     */
    DisputeReason["REFUND_NOT_RECEIVED"] = "REFUND_NOT_RECEIVED";
    /**
     * NO_VALID_AUTHORIZATION - The merchant processed a transaction without first obtaining a correct and valid authorization approval.
     * In app, users will select REASON_OTHER but admin can change to this before submitting to issuer.
     */
    DisputeReason["NO_VALID_AUTHORIZATION"] = "NO_VALID_AUTHORIZATION";
    /**
     * REASON_OTHER - Some other reason.
     */
    DisputeReason["REASON_OTHER"] = "REASON_OTHER";
    DisputeReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DisputeReason || (exports.DisputeReason = DisputeReason = {}));
var DisputeCloseReason;
(function (DisputeCloseReason) {
    DisputeCloseReason["INVALID_DISPUTE_CLOSE_REASON"] = "INVALID_DISPUTE_CLOSE_REASON";
    /**
     * REJECTED - Not a valid dispute.
     */
    DisputeCloseReason["REJECTED"] = "REJECTED";
    /**
     * MERCHANT_RESOLVED - The dispute was resolved directly with the merchant.
     */
    DisputeCloseReason["MERCHANT_RESOLVED"] = "MERCHANT_RESOLVED";
    /**
     * NO_RESPONSE - The user has been unresponsive for e.g. 30 days.
     */
    DisputeCloseReason["NO_RESPONSE"] = "NO_RESPONSE";
    /**
     * RETRACTED - The user decided to withdraw their dispute.
     */
    DisputeCloseReason["RETRACTED"] = "RETRACTED";
    /**
     * PARTIAL_CREDIT - A partial credit was given to the user by Step.
     */
    DisputeCloseReason["PARTIAL_CREDIT"] = "PARTIAL_CREDIT";
    /**
     * REFUNDED - A full refund was given to the user by Step.
     */
    DisputeCloseReason["REFUNDED"] = "REFUNDED";
    /**
     * AUTO_REFUNDED - The dispute was resolved automatically.
     */
    DisputeCloseReason["AUTO_REFUNDED"] = "AUTO_REFUNDED";
    /**
     * CLOSE_REASON_OTHER - For any other reason, in which we take no action(s).
     */
    DisputeCloseReason["CLOSE_REASON_OTHER"] = "CLOSE_REASON_OTHER";
    /**
     * ISSUER_WON - The dispute was resolved in favor of the user.
     */
    DisputeCloseReason["ISSUER_WON"] = "ISSUER_WON";
    /**
     * ISSUER_LOST - The dispute was declined by the issuer and any credit was reverted.
     */
    DisputeCloseReason["ISSUER_LOST"] = "ISSUER_LOST";
    /**
     * RETRACTED_IN_APP - The dispute was retracted by the user in the app.
     */
    DisputeCloseReason["RETRACTED_IN_APP"] = "RETRACTED_IN_APP";
    DisputeCloseReason["UNRECOGNIZED"] = "UNRECOGNIZED";
})(DisputeCloseReason || (exports.DisputeCloseReason = DisputeCloseReason = {}));
function disputeReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DISPUTE_REASON':
            return DisputeReason.INVALID_DISPUTE_REASON;
        case 1:
        case 'UNRECOGNIZED_CHARGE':
            return DisputeReason.UNRECOGNIZED_CHARGE;
        case 2:
        case 'DUPLICATE_CHARGE':
            return DisputeReason.DUPLICATE_CHARGE;
        case 3:
        case 'PRODUCT_NOT_RECEIVED':
            return DisputeReason.PRODUCT_NOT_RECEIVED;
        case 4:
        case 'WRONG_PRODUCT':
            return DisputeReason.WRONG_PRODUCT;
        case 5:
        case 'REFUND_NOT_RECEIVED':
            return DisputeReason.REFUND_NOT_RECEIVED;
        case 7:
        case 'NO_VALID_AUTHORIZATION':
            return DisputeReason.NO_VALID_AUTHORIZATION;
        case 6:
        case 'REASON_OTHER':
            return DisputeReason.REASON_OTHER;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DisputeReason.UNRECOGNIZED;
    }
}
exports.disputeReasonFromJSON = disputeReasonFromJSON;
function disputeReasonToJSON(object) {
    switch (object) {
        case DisputeReason.INVALID_DISPUTE_REASON:
            return 'INVALID_DISPUTE_REASON';
        case DisputeReason.UNRECOGNIZED_CHARGE:
            return 'UNRECOGNIZED_CHARGE';
        case DisputeReason.DUPLICATE_CHARGE:
            return 'DUPLICATE_CHARGE';
        case DisputeReason.PRODUCT_NOT_RECEIVED:
            return 'PRODUCT_NOT_RECEIVED';
        case DisputeReason.WRONG_PRODUCT:
            return 'WRONG_PRODUCT';
        case DisputeReason.REFUND_NOT_RECEIVED:
            return 'REFUND_NOT_RECEIVED';
        case DisputeReason.NO_VALID_AUTHORIZATION:
            return 'NO_VALID_AUTHORIZATION';
        case DisputeReason.REASON_OTHER:
            return 'REASON_OTHER';
        case DisputeReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.disputeReasonToJSON = disputeReasonToJSON;
function disputeCloseReasonFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_DISPUTE_CLOSE_REASON':
            return DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        case 1:
        case 'REJECTED':
            return DisputeCloseReason.REJECTED;
        case 2:
        case 'MERCHANT_RESOLVED':
            return DisputeCloseReason.MERCHANT_RESOLVED;
        case 3:
        case 'NO_RESPONSE':
            return DisputeCloseReason.NO_RESPONSE;
        case 4:
        case 'RETRACTED':
            return DisputeCloseReason.RETRACTED;
        case 5:
        case 'PARTIAL_CREDIT':
            return DisputeCloseReason.PARTIAL_CREDIT;
        case 6:
        case 'REFUNDED':
            return DisputeCloseReason.REFUNDED;
        case 7:
        case 'AUTO_REFUNDED':
            return DisputeCloseReason.AUTO_REFUNDED;
        case 8:
        case 'CLOSE_REASON_OTHER':
            return DisputeCloseReason.CLOSE_REASON_OTHER;
        case 98:
        case 'ISSUER_WON':
            return DisputeCloseReason.ISSUER_WON;
        case 99:
        case 'ISSUER_LOST':
            return DisputeCloseReason.ISSUER_LOST;
        case 100:
        case 'RETRACTED_IN_APP':
            return DisputeCloseReason.RETRACTED_IN_APP;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return DisputeCloseReason.UNRECOGNIZED;
    }
}
exports.disputeCloseReasonFromJSON = disputeCloseReasonFromJSON;
function disputeCloseReasonToJSON(object) {
    switch (object) {
        case DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON:
            return 'INVALID_DISPUTE_CLOSE_REASON';
        case DisputeCloseReason.REJECTED:
            return 'REJECTED';
        case DisputeCloseReason.MERCHANT_RESOLVED:
            return 'MERCHANT_RESOLVED';
        case DisputeCloseReason.NO_RESPONSE:
            return 'NO_RESPONSE';
        case DisputeCloseReason.RETRACTED:
            return 'RETRACTED';
        case DisputeCloseReason.PARTIAL_CREDIT:
            return 'PARTIAL_CREDIT';
        case DisputeCloseReason.REFUNDED:
            return 'REFUNDED';
        case DisputeCloseReason.AUTO_REFUNDED:
            return 'AUTO_REFUNDED';
        case DisputeCloseReason.CLOSE_REASON_OTHER:
            return 'CLOSE_REASON_OTHER';
        case DisputeCloseReason.ISSUER_WON:
            return 'ISSUER_WON';
        case DisputeCloseReason.ISSUER_LOST:
            return 'ISSUER_LOST';
        case DisputeCloseReason.RETRACTED_IN_APP:
            return 'RETRACTED_IN_APP';
        case DisputeCloseReason.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.disputeCloseReasonToJSON = disputeCloseReasonToJSON;
//# sourceMappingURL=dispute-reason.js.map